import "core-js/modules/es.array.push.js";
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'print',
  data() {
    return {};
  },
  methods: {
    page() {
      this.$router.push('/faqs');
    }
  }
});